var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h5',[_vm._v("Reittienhallinta 2.3.1")]),_vm._v(" "),_c('v-img',{attrs:{"src":"usermanual/edit_route1.png"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }